/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .controller('setAutoRegPasswordSuccessCtrl', SetAutoRegPasswordSuccessCtrl);

  SetAutoRegPasswordSuccessCtrl.$inject = ['setPasswordService', 'timerService', 'ute.easy.login.registration.service'];

  function SetAutoRegPasswordSuccessCtrl(setPasswordService, timerService, easyLoginRegistrationService) {
    var ctrl = this;

    init();

    function init() {
      timerService.stopTimer();
      ctrl.getUsername = setPasswordService.getUsername;
      ctrl.gotoAccountOverview = easyLoginRegistrationService.gotoAccountOverviewAfterLogin;
    }
  }
})();
